import styled from 'styled-components';
import SvgIcon from '../SvgIcon';

const IconSetDefault = styled(SvgIcon).attrs({
  children: ({ color }: { color: string }) => (
    <path
      d="M6.707 7.793 12.5 2 14 3.5l-7.293 7.121L2 5.914 3.414 4.5l3.293 3.293ZM2 12v2h12v-2H2Z"
      fillRule="evenodd"
      fill={color}
    />
  ),
})``;

export default IconSetDefault;
